import React from "react";
import CustomerVehicleHireStatusType from "../common/enum/CustomerVehicleHireStatusType";
import {formatDateTime} from "../common/util/FormatUtil";

interface VehicleHireStatusBadgeProps {
    vehicleHire: CustomerAPIVehicleHire
}

const VehicleHireStatusBadge = (props: VehicleHireStatusBadgeProps) => {

    const formatTimestamp = (input: string | null | undefined) => {
        if (!input) {
            return "";
        }
        return formatDateTime(new Date(input));
    }

    const { vehicleHire } = props;
    const status = CustomerVehicleHireStatusType.valueOf(vehicleHire.status)!;

    return (
        <>
            <span className="badge p-2" style={{
                backgroundColor: status.colour,
                color: 'white',
                fontWeight: '500',
                overflow: 'wrap'
            }}>{status.description}</span>
            {status === CustomerVehicleHireStatusType.COMPLETED &&
                <span style={{fontSize: '80%'}}><br />{formatTimestamp(vehicleHire.completedAt)}</span>
            }
            {status === CustomerVehicleHireStatusType.STARTED && vehicleHire.startedAt &&
                <span style={{fontSize: '80%'}}><br />{formatTimestamp(vehicleHire.startedAt)}</span>
            }
        </>
    );


}

export default VehicleHireStatusBadge;
